// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * @Author: Yoney Y (YuTianyuan)
 * @Date: 2021-12-10 13:44:27
 * @Last Modified by: undefined (ZhangZeHao)
 * @Last Modified time: 2022-04-27 10:50:38
 */
.flex {
  display: flex;
}
.flex-shrink {
  flex-shrink: 0;
}
.flex-wrap {
  flex-wrap: wrap;
}
.flex-direction-row {
  flex-direction: row;
}
.flex-direction-column {
  flex-direction: column;
}
.flex-align-items-center {
  align-items: center;
}
.flex-align-items-start {
  align-items: flex-start;
}
.flex-align-items-end {
  align-items: flex-end;
}
.flex-align-self-start {
  align-self: flex-start;
}
.flex-align-self-end {
  align-self: flex-end;
}
.flex-align-self-center {
  align-self: center;
}
.flex-align-self-baseline {
  align-self: baseline;
}
.flex-justify-content-center {
  justify-content: center;
}
.flex-justify-content-start {
  justify-content: flex-start;
}
.flex-justify-content-end {
  justify-content: flex-end;
}
.flex-justify-content-space-between {
  justify-content: space-between;
}
.flex-justify-content-space-around {
  justify-content: space-around;
}
.flex-1 {
  flex: 1;
}
.flex-2 {
  flex: 2;
}
.flex-3 {
  flex: 3;
}
.flex-4 {
  flex: 4;
}
.flex-5 {
  flex: 5;
}
.flex-6 {
  flex: 6;
}
.flex-7 {
  flex: 7;
}
.flex-8 {
  flex: 8;
}
.flex-9 {
  flex: 9;
}
.flex-10 {
  flex: 10;
}
.flex-11 {
  flex: 11;
}
.flex-12 {
  flex: 12;
}
.flex-13 {
  flex: 13;
}
.flex-14 {
  flex: 14;
}
.flex-15 {
  flex: 15;
}
.flex-16 {
  flex: 16;
}
.flex-17 {
  flex: 17;
}
.flex-18 {
  flex: 18;
}
.flex-19 {
  flex: 19;
}
.flex-20 {
  flex: 20;
}
.flex-21 {
  flex: 21;
}
.flex-22 {
  flex: 22;
}
.flex-23 {
  flex: 23;
}
.flex-24 {
  flex: 24;
}
.odd-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.more-overflow {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}
:root {
  --theme-main-color: #3A7FFF;
  --theme-comm-color: #926DF1;
  --theme-bg-color: #F2F3F7;
  --theme-main-bg-color: #FFFFFF;
  --theme-text-color: #000;
  --theme-title-color: #333;
  --theme-active-color: #448FF7;
  --theme-button-color: #448FF7;
  --theme-padding: 20px;
}
* {
  margin: 0;
  padding: 0;
  list-style: none;
  text-decoration: none;
  box-sizing: border-box;
  font-family: "PingFangSC-Regular", sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, apple color emoji, segoe ui emoji, Segoe UI Symbol, noto color emoji;
  -webkit-tap-highlight-color: transparent;
}
html,
body,
#root,
#App {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
input,
textarea,
button,
video {
  outline: none;
  vertical-align: middle;
  -webkit-appearance: none;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/rest.less","webpack://./src/assets/styles/flex.less","webpack://./src/assets/styles/variable.less"],"names":[],"mappings":"AAAA;;;;;EAKE;ACFF;EACE,aAAA;ADIF;ACDA;EACE,cAAA;ADGF;ACAA;EACE,eAAA;ADEF;ACCA;EACE,mBAAA;ADCF;ACEA;EACE,sBAAA;ADAF;ACGA;EACE,mBAAA;ADDF;ACIA;EACE,uBAAA;ADFF;ACKA;EACE,qBAAA;ADHF;ACMA;EACE,sBAAA;ADJF;ACOA;EACE,oBAAA;ADLF;ACQA;EACE,kBAAA;ADNF;ACSA;EACE,oBAAA;ADPF;ACUA;EACE,uBAAA;ADRF;ACWA;EACE,2BAAA;ADTF;ACYA;EACE,yBAAA;ADVF;ACaA;EACE,8BAAA;ADXF;ACcA;EACE,6BAAA;ADZF;ACgBG;EACC,OAAA;ADdJ;ACaG;EACC,OAAA;ADXJ;ACUG;EACC,OAAA;ADRJ;ACOG;EACC,OAAA;ADLJ;ACIG;EACC,OAAA;ADFJ;ACCG;EACC,OAAA;ADCJ;ACFG;EACC,OAAA;ADIJ;ACLG;EACC,OAAA;ADOJ;ACRG;EACC,OAAA;ADUJ;ACXG;EACC,QAAA;ADaJ;ACdG;EACC,QAAA;ADgBJ;ACjBG;EACC,QAAA;ADmBJ;ACpBG;EACC,QAAA;ADsBJ;ACvBG;EACC,QAAA;ADyBJ;AC1BG;EACC,QAAA;AD4BJ;AC7BG;EACC,QAAA;AD+BJ;AChCG;EACC,QAAA;ADkCJ;ACnCG;EACC,QAAA;ADqCJ;ACtCG;EACC,QAAA;ADwCJ;ACzCG;EACC,QAAA;AD2CJ;AC5CG;EACC,QAAA;AD8CJ;AC/CG;EACC,QAAA;ADiDJ;AClDG;EACC,QAAA;ADoDJ;ACrDG;EACC,QAAA;ADuDJ;AC5CA;EACE,gBAAA;EACA,uBAAA;EACA,mBAAA;AD8CF;AC1CA;EACE,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,4BAAA;AD4CF;AE3IA;EACE,2BAAA;EACA,2BAAA;EACA,yBAAA;EACA,8BAAA;EACA,wBAAA;EACA,yBAAA;EAEA,6BAAA;EACA,6BAAA;EAEA,qBAAA;AF2IF;AA5IA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,qBAAA;EACA,sBAAA;EACA,sNAAA;EACA,wCAAA;AA8IF;AA3IA;;;;EAIE,WAAA;EACA,YAAA;EACA,sBAAA;AA6IF;AA1IA;;;;EAIE,aAAA;EACA,sBAAA;EACA,wBAAA;AA4IF","sourcesContent":["/*\n * @Author: Yoney Y (YuTianyuan)\n * @Date: 2021-12-10 13:44:27\n * @Last Modified by: undefined (ZhangZeHao)\n * @Last Modified time: 2022-04-27 10:50:38\n */\n\n@import url('./flex.less');\n@import url('./variable.less');\n\n* {\n  margin                     : 0;\n  padding                    : 0;\n  list-style                 : none;\n  text-decoration            : none;\n  box-sizing                 : border-box;\n  font-family                : \"PingFangSC-Regular\", sans-serif, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica Neue, Arial, Noto Sans, sans-serif, apple color emoji, segoe ui emoji, Segoe UI Symbol, noto color emoji;\n  -webkit-tap-highlight-color: transparent;\n}\n\nhtml,\nbody,\n#root,\n#App {\n  width           : 100%;\n  height          : 100%;\n  background-color: #fff;\n}\n\ninput,\ntextarea,\nbutton,\nvideo {\n  outline           : none;\n  vertical-align    : middle;\n  -webkit-appearance: none;\n}","\n// Flex 常用Css属性\n\n.flex {\n  display: flex;\n}\n\n.flex-shrink {\n  flex-shrink: 0;\n}\n\n.flex-wrap {\n  flex-wrap: wrap;\n}\n\n.flex-direction-row {\n  flex-direction: row;\n}\n\n.flex-direction-column {\n  flex-direction: column;\n}\n\n.flex-align-items-center {\n  align-items: center;\n}\n\n.flex-align-items-start {\n  align-items: flex-start;\n}\n\n.flex-align-items-end {\n  align-items: flex-end;\n}\n\n.flex-align-self-start {\n  align-self: flex-start;\n}\n\n.flex-align-self-end {\n  align-self: flex-end;\n}\n\n.flex-align-self-center {\n  align-self: center;\n}\n\n.flex-align-self-baseline {\n  align-self: baseline;\n}\n\n.flex-justify-content-center {\n  justify-content: center;\n}\n\n.flex-justify-content-start {\n  justify-content: flex-start;\n}\n\n.flex-justify-content-end {\n  justify-content: flex-end;\n}\n\n.flex-justify-content-space-between {\n  justify-content: space-between;\n}\n\n.flex-justify-content-space-around {\n  justify-content: space-around;\n}\n\n.flexLoop(@index) when(@index <=24) {\n  .flex-@{index} {\n    flex: @index\n  }\n\n  .flexLoop(@index + 1)\n}\n\n.flexLoop(1);\n\n// tools 工具Css属性\n\n// 单行溢出省略号\n.odd-overflow {\n  overflow     : hidden;\n  text-overflow: ellipsis;\n  white-space  : nowrap;\n}\n\n// 多行溢出省略号\n.more-overflow {\n  overflow             : hidden;\n  text-overflow        : ellipsis;\n  display              : -webkit-box;\n  -webkit-box-orient   : vertical;\n  // display: -moz-box;\n  // display: -moz-inline-box;\n  // display: -webkit-inline-box;\n  // -moz-box-orient: vertical;\n  // -webkit-line-clamp: 2;\n  // line-clamp: 2;\n}",":root {\n  --theme-main-color   : #3A7FFF;\n  --theme-comm-color   : #926DF1;\n  --theme-bg-color     : #F2F3F7;\n  --theme-main-bg-color: #FFFFFF;\n  --theme-text-color   : #000;\n  --theme-title-color  : #333;\n\n  --theme-active-color: #448FF7;\n  --theme-button-color: #448FF7;\n\n  --theme-padding: 20px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
